"use strict";

exports.__esModule = true;
exports.NewLogbookTicket = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _Theme = require("../../Theme");
var _NewLogbookTicketForm = require("./NewLogbookTicketForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NewEventHeader = _styledComponents["default"].div.withConfig({
  displayName: "NewLogbookTicket__NewEventHeader",
  componentId: "sc-1sc8ud2-0"
})(["background:", ";display:flex;justify-content:space-between;align-items:center;padding:0 0.8rem;height:48px;"], (0, _Theme.val)("LogBookNewEventBackground"));
var NewEventHeading = (0, _styledComponents["default"])(_Core.Heading).withConfig({
  displayName: "NewLogbookTicket__NewEventHeading",
  componentId: "sc-1sc8ud2-1"
})(["padding:0;margin:0;"]);
var NewEventForm = _styledComponents["default"].div.withConfig({
  displayName: "NewLogbookTicket__NewEventForm",
  componentId: "sc-1sc8ud2-2"
})(["padding:0.8rem;"]);
var NewLogbookTicket = exports.NewLogbookTicket = function NewLogbookTicket(_ref) {
  var logbook = _ref.logbook,
    closeNewEvent = _ref.closeNewEvent;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(NewEventHeader, {
    "data-testid": "NewLogbookTicket"
  }, /*#__PURE__*/_react["default"].createElement(NewEventHeading, {
    level: "4"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "NewLogbookTicket.createTicketTitle",
    defaultMessage: "Create new ticket"
  })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    minimal: true,
    icon: _icons.IconNames.CROSS,
    onClick: closeNewEvent
  })), /*#__PURE__*/_react["default"].createElement(NewEventForm, null, /*#__PURE__*/_react["default"].createElement(_NewLogbookTicketForm.NewLogbookTicketForm, {
    device: logbook.device,
    filteredTicketTypes: logbook.filteredTicketTypes,
    ticketTypes: logbook.nonDeviceTicketTypes
  })));
};